import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";

import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import TeamPage from "@/pages/TeamPage";
import AppointmentPage from "@/pages/AppointmentPage";
import QuotePage from "@/pages/QuotePage";
import ContactPage from "@/pages/ContactPage";
import { NewsListPage, ArticlePage } from "@/pages/NewsPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import { AdminLayout, AdminAppointments, AdminQuotes, AdminArticles } from "@/pages/admin/AdminPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <FloatingCTAs />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
            <Route path="/equipe" element={<PublicLayout><TeamPage /></PublicLayout>} />
            <Route path="/rendez-vous" element={<PublicLayout><AppointmentPage /></PublicLayout>} />
            <Route path="/devis" element={<PublicLayout><QuotePage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/actualites" element={<PublicLayout><NewsListPage /></PublicLayout>} />
            <Route path="/actualites/:slug" element={<PublicLayout><ArticlePage /></PublicLayout>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminAppointments />} />
              <Route path="devis" element={<AdminQuotes />} />
              <Route path="articles" element={<AdminArticles />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
